import { hasOwnProperty } from "@core/utils/type-utils";

export interface ApiError {
	path: string;
	status: number;
	code?: string;
	message?: string;
}

export function isApiError(error: unknown): error is ApiError {
	if (error === null || error === undefined || typeof error !== "object") {
		return false;
	}

	if (!hasOwnProperty(error, "path") || typeof error.path !== "string") {
		return false;
	}

	if (!hasOwnProperty(error, "status") || typeof error.status !== "number") {
		return false;
	}

	return true;
}
